// ratingOptions.js

import { FaPen, FaStar, FaCrown } from "react-icons/fa6"; 
import { TbLadder } from "react-icons/tb"; 

export const RATING_OPTIONS = [
  { key: "pen",    label: "ناشئ",  icon: FaPen,    color: "#5199E4", value: 1 }, // أزرق صافي ومريح
  { key: "ladder", label: "نام",   icon: TbLadder, color: "#69BD7D", value: 2 }, // أخضر عشبي هادئ
  { key: "star",   label: "متمكن", icon: FaStar,   color: "#E5A14C", value: 3 }, // ذهبي/برتقالي دافئ
  { key: "crown",  label: "متقدم", icon: FaCrown,  color: "#AC74C2", value: 4 }, // بنفسجي فاتح واضح
];